import API from './API.js'
import axios from 'axios'

export default class QuranScheduleDateUser extends API {
  constructor() {
    super('quran_schedule_date_user')
  }

  async GetTeacherSchedules(params) {
    const res = await axios.get(`GetTeacherSchedules`, { params })
    return res.data
  }

  async GetTeachersOptions() {
    const res = await axios.get(`GetTeachersOptions`);
    return res.data
  }
   

  async GetTeacherStudents(params) {
    const res = await axios.get(`GetTeacherStudents`, { params })
    return res.data
  }
 
}
